module.exports = require("live/components/actions/ui/confirmation-dialog");